import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  GoogleMap,
  LoadScript,
  Autocomplete,
  Marker,
} from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "../redux/api/Constants";

const libraries = ["places"];

const containerStyle = {
  width: "100%",
  height: "50vh",
};

const GoogleMapPages = ({
  setLatitude,
  latitude,
  longitude,
  setLongitude,
  edit,
}) => {
  // console.log("latitude", latitude, longitude);
  // let center = {};
  // useEffect(() => {
  //   center = {
  //     lat: latitude && latitude,
  //     lng: longitude & longitude,
  //   };
  // }, [latitude, longitude]);
  // console.log("center", center);

  // const [mapCenter, setMapCenter] = useState(center);
  // const mapRef = useRef(null);
  // const autoCompleteRef = useRef(null);
  // console.log("mapCenter", mapCenter);
  // const onLoad = useCallback((map) => {
  //   mapRef.current = map;
  //   setLatitude(center?.lat);
  //   setLongitude(center?.lng);
  // }, []);

  // const onCenterChanged = () => {
  //   if (mapRef.current) {
  //     const newCenter = {
  //       lat: mapRef.current.getCenter().lat(),
  //       lng: mapRef.current.getCenter().lng(),
  //     };
  //     setMapCenter(newCenter);
  //     setLatitude(newCenter?.lat);
  //     setLongitude(newCenter?.lng);
  //   }
  // };

  // const onAutoCompleteLoad = (autocomplete) => {
  //   autoCompleteRef.current = autocomplete;
  // };

  // const onPlaceChanged = () => {
  //   if (autoCompleteRef.current !== null) {
  //     const place = autoCompleteRef.current.getPlace();
  //     if (place.geometry) {
  //       const newPos = {
  //         lat: place.geometry.location.lat(),
  //         lng: place.geometry.location.lng(),
  //       };
  //       setMapCenter(newPos);
  //       setLatitude(newPos?.lat);
  //       setLongitude(newPos?.lng);
  //       mapRef.current.panTo(newPos);
  //     }
  //   }
  // };

  // const mapOptions = {
  //   fullscreenControl: false, // Hide fullscreen button
  //   mapTypeControl: false, // Hide map/satellite toggle
  //   streetViewControl: false, // Hide street view pegman
  //   zoomControl: false, // Hide zoom in/out buttons
  //   rotateControl: false, // Hide compass/rotate
  //   scaleControl: false, // Hide scale bottom left
  //   clickableIcons: false, // Disable default place icons
  //   disableDefaultUI: false, // Keep default UI if needed, or true to hide all
  // };

  // console.log("edit", edit);
  // Initialize state with latitude/longitude props
  const [mapCenter, setMapCenter] = useState({
    lat: latitude || null,
    lng: longitude || null,
  });

  const mapRef = useRef(null);
  const autoCompleteRef = useRef(null);

  // Update mapCenter when latitude/longitude props change
  useEffect(() => {
    if (latitude && longitude) {
      setMapCenter({
        lat: latitude,
        lng: longitude,
      });
    }
  }, [latitude, longitude]);

  console.log("mapCenter", mapCenter);

  const onLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const onCenterChanged = () => {
    if (mapRef.current) {
      const newCenter = {
        lat: mapRef.current.getCenter().lat(),
        lng: mapRef.current.getCenter().lng(),
      };
      setMapCenter(newCenter);
      setLatitude(newCenter.lat);
      setLongitude(newCenter.lng);
    }
  };

  const onAutoCompleteLoad = (autocomplete) => {
    autoCompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autoCompleteRef.current !== null) {
      const place = autoCompleteRef.current.getPlace();
      if (place.geometry) {
        const newPos = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setMapCenter(newPos);
        setLatitude(newPos.lat);
        setLongitude(newPos.lng);
        mapRef.current.panTo(newPos);
      }
    }
  };

  const mapOptions = {
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false,
    rotateControl: false,
    scaleControl: false,
    clickableIcons: false,
    disableDefaultUI: false,
  };

  return (
    <div>
      {" "}
      <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
        Map Location ajdlaskj
      </h4>
      <div>
        <LoadScript googleMapsApiKey={GOOGLE_MAP_KEY} libraries={libraries}>
          <div
            className="p-4"
            style={{
              width: "100%",
              border: "1px solid rgb(179 218 185)",
              position: "relative",
            }}
          >
            {edit && (
              <Autocomplete
                onLoad={onAutoCompleteLoad}
                onPlaceChanged={onPlaceChanged}
                className="d-flex justify-content-center"
              >
                <input
                  type="text"
                  placeholder="Search a place"
                  style={{
                    width: "40%",
                    padding: "12px 16px",
                    borderRadius: "12px",
                    border: "1px solid #ccc",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    fontSize: "16px",
                    outline: "none",
                    zIndex: 1,
                    position: "absolute",
                    margin: "2%",
                  }}
                />
              </Autocomplete>
            )}

            <GoogleMap
              mapContainerStyle={containerStyle}
              center={mapCenter}
              zoom={14}
              options={mapOptions}
              onLoad={onLoad}
              // onIdle={onCenterChanged}
              onDragEnd={onCenterChanged}
            >
              <Marker position={mapCenter} />
            </GoogleMap>
          </div>
        </LoadScript>
      </div>
    </div>
  );
};

export default GoogleMapPages;
